import React, { useState } from "react";
import toggleFullscreen from "toggle-fullscreen";
import styles from "./fullscreen-button.module.scss";
import PropTypes from "prop-types";
import { Compress, Expand } from "../icons/icons";

export default function FullscreenButton({ rootEl }) {
  const [isFullscreen, setIsFullscreen] = useState(false);

  return (
    <button
      className={styles.fullscreenButton}
      onClick={e => {
        const element = rootEl;
        setIsFullscreen(x => !x);
        toggleFullscreen(element).catch(console.log);
      }}
    >
      {isFullscreen ? (
        <Compress style={{ width: "100%", height: "100%" }} />
      ) : (
        <Expand style={{ width: "100%", height: "100%" }} />
      )}
    </button>
  );
}

FullscreenButton.propTypes = {
  rootEl: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/fullscreen-button/fullscreen-button.js